import PartyModal from "./PartyModal";

export default PartyModal;
